export const UPDATE_VALUE = "CLICK_UPDATE_VALUE";
export const UPDATE_VALUE_ARRAY = "CLICK_UPDATE_VALUE_ARRAY";
export const CLEAR_VALUE = "CLEAR_VALUE";
export const ADD_LANGUAGE = "ADD_LANGUAGE";
export const REMOVE_LANGUAGE = "REMOVE_LANGUAGE";
export const SET_FINISH = "SET_FINISH";
